// Generator-discovered file route for reports Tier 2 (per-domain within a
// vertical — Module P / P10). Reads the `verticalId` search param and passes it
// to the component. Component lives in `src/ad/routes/reports.domains.tsx`.
import { createFileRoute } from '@tanstack/react-router';
import { ReportsDomainsRouteComponent } from '@/ad/routes/reports.domains';

function parseVerticalId(search: Record<string, unknown>): { verticalId?: number } {
  const raw = search.verticalId;
  const n = typeof raw === 'number' ? raw : Number(raw);
  return Number.isInteger(n) && n > 0 ? { verticalId: n } : {};
}

export const Route = createFileRoute('/_authenticated/ad/reports/domains')({
  validateSearch: parseVerticalId,
  component: ReportsDomainsRoute,
});

function ReportsDomainsRoute(): React.ReactElement {
  const { verticalId } = Route.useSearch();
  return <ReportsDomainsRouteComponent verticalId={verticalId} />;
}
